import { useState, useRef, useEffect } from "react";
import { upsertGtdTicket, removeGtdTicket } from "../api/gtd.api";

export const GTD_CATEGORIA_COLOR = {
  "Imediatamente": "#f87171",
  "Urgente":       "#fb923c",
  "Monitorar":     "#fbbf24",
  "Aguardar":      "#60a5fa",
  "Algum dia":     "#94a3b8",
  "Finalizados":   "#4ade80",
};

const CATEGORIAS = ["Imediatamente", "Urgente", "Monitorar", "Aguardar", "Algum dia", "Finalizados"];

/* Botão + popover para atribuir rapidamente um ticket a uma categoria do quadro GTD.
   Usado nas telas de Setup/Devs — não depende da página do quadro estar aberta. */
export default function GtdQuickAssign({ idTicket, categoriaAtual, observacaoAtual, onChanged }) {
  const [open,       setOpen]       = useState(false);
  const [categoria,  setCategoria]  = useState(categoriaAtual || "");
  const [observacao, setObservacao] = useState(observacaoAtual || "");
  const [saving,     setSaving]     = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return;
    function onClickOutside(e) {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    }
    document.addEventListener("mousedown", onClickOutside);
    return () => document.removeEventListener("mousedown", onClickOutside);
  }, [open]);

  useEffect(() => {
    setCategoria(categoriaAtual || "");
    setObservacao(observacaoAtual || "");
  }, [categoriaAtual, observacaoAtual]);

  async function handleAssign(cat) {
    setSaving(true);
    try {
      const registro = await upsertGtdTicket(idTicket, cat, observacao.trim() || null);
      setCategoria(cat);
      onChanged?.(registro);
      setOpen(false);
    } catch {
      alert("Erro ao atribuir ticket ao GTD.");
    } finally {
      setSaving(false);
    }
  }

  async function handleRemove() {
    setSaving(true);
    try {
      await removeGtdTicket(idTicket);
      setCategoria("");
      setObservacao("");
      onChanged?.(null);
      setOpen(false);
    } catch {
      alert("Erro ao remover ticket do GTD.");
    } finally {
      setSaving(false);
    }
  }

  const cor = GTD_CATEGORIA_COLOR[categoria];

  return (
    <div style={{ position: "relative", display: "inline-block" }} ref={ref}>
      <button
        style={categoria ? { ...btn, color: cor, borderColor: `${cor}55`, background: `${cor}14` } : btn}
        onClick={() => setOpen(v => !v)}
        title="Atribuir ao quadro GTD"
      >
        {categoria || "→ GTD"}
      </button>

      {open && (
        <div style={popover} onClick={e => e.stopPropagation()}>
          <div style={popoverTitle}>Quadro GTD</div>
          <div style={catList}>
            {CATEGORIAS.map(c => (
              <button
                key={c}
                disabled={saving}
                style={{
                  ...catBtn,
                  color: GTD_CATEGORIA_COLOR[c],
                  borderColor: c === categoria ? GTD_CATEGORIA_COLOR[c] : `${GTD_CATEGORIA_COLOR[c]}33`,
                  background: c === categoria ? `${GTD_CATEGORIA_COLOR[c]}20` : "transparent",
                }}
                onClick={() => handleAssign(c)}
              >
                {c}
              </button>
            ))}
          </div>
          <textarea
            style={obsInput}
            placeholder="Observação (opcional)..."
            value={observacao}
            onChange={e => setObservacao(e.target.value)}
          />
          {categoria && (
            <button style={removeBtn} disabled={saving} onClick={handleRemove}>
              Remover do quadro
            </button>
          )}
        </div>
      )}
    </div>
  );
}

const btn = {
  padding: "3px 9px",
  borderRadius: 6,
  border: "1px solid rgba(96,165,250,0.2)",
  background: "rgba(96,165,250,0.06)",
  color: "#60a5fa",
  fontSize: 10,
  fontWeight: 700,
  cursor: "pointer",
  whiteSpace: "nowrap",
};

const popover = {
  position: "absolute",
  top: "calc(100% + 6px)",
  right: 0,
  zIndex: 50,
  width: 220,
  background: "#0b1629",
  border: "1px solid rgba(96,165,250,0.2)",
  borderRadius: 10,
  padding: 12,
  boxShadow: "0 8px 28px rgba(0,0,0,0.45)",
  display: "flex",
  flexDirection: "column",
  gap: 8,
};

const popoverTitle = {
  fontSize: 10,
  fontWeight: 700,
  color: "#475569",
  textTransform: "uppercase",
  letterSpacing: 0.6,
};

const catList = { display: "flex", flexDirection: "column", gap: 4 };

const catBtn = {
  padding: "6px 9px",
  borderRadius: 7,
  border: "1px solid",
  fontSize: 11,
  fontWeight: 600,
  cursor: "pointer",
  textAlign: "left",
};

const obsInput = {
  width: "100%",
  height: 54,
  resize: "vertical",
  padding: "6px 8px",
  borderRadius: 7,
  border: "1px solid rgba(96,165,250,0.15)",
  background: "rgba(11,22,42,0.7)",
  color: "#e2e8f0",
  fontSize: 11,
  outline: "none",
  boxSizing: "border-box",
  fontFamily: "inherit",
};

const removeBtn = {
  padding: "5px 8px",
  borderRadius: 7,
  border: "1px solid rgba(248,113,113,0.25)",
  background: "rgba(248,113,113,0.06)",
  color: "#f87171",
  fontSize: 10,
  fontWeight: 600,
  cursor: "pointer",
};
